module.exports = __webpack_public_path__ + "img/prioritas_dfod_k.1e9b0d7b.png";